import { jsxs as L, jsx as p } from "react/jsx-runtime";
import { Flex as W, Text as z } from "@chakra-ui/react";
import { firstLetterUpperCase as S } from "./helper.js";
import { startOfMonth as u } from "../../node_modules/date-fns/startOfMonth.js";
import { isBefore as O } from "../../node_modules/date-fns/isBefore.js";
import { isSameMonth as G } from "../../node_modules/date-fns/isSameMonth.js";
import { IconButton as l } from "../icon-button/icon-button.js";
import { Icons as w } from "../icon/types.js";
import { subMonths as Y } from "../../node_modules/date-fns/subMonths.js";
import { subWeeks as q } from "../../node_modules/date-fns/subWeeks.js";
import { subDays as c } from "../../node_modules/date-fns/subDays.js";
import { getISOWeek as A } from "../../node_modules/date-fns/getISOWeek.js";
import { addMonths as C } from "../../node_modules/date-fns/addMonths.js";
import { addWeeks as J } from "../../node_modules/date-fns/addWeeks.js";
import { addDays as D } from "../../node_modules/date-fns/addDays.js";
import { sv as K } from "../../node_modules/date-fns/locale/sv.js";
import { da as N } from "../../node_modules/date-fns/locale/da.js";
import { nb as Q } from "../../node_modules/date-fns/locale/nb.js";
import { enGB as F } from "../../node_modules/date-fns/locale/en-GB.js";
import { enUS as x } from "../../node_modules/date-fns/locale/en-US.js";
import { isSameYear as X } from "../../node_modules/date-fns/isSameYear.js";
import { ThemeSpaceVariable as Z, ThemeFontSizeVariable as _, ThemeFontVariable as E } from "../../theme/theme-types.js";
import { formatDate as b } from "../../node_modules/date-fns/format.js";
const Fr = ({
  onMonthChange: k,
  selectedMonth: e,
  month: d,
  selectWeek: m,
  locale: o,
  selectedDate: i,
  onDateChange: a,
  isExpanded: f,
  disablePastMonths: P,
  disableBackwardNavigation: B,
  disableForwardNavigation: T,
  dateRange: t,
  onRangeChange: s
}) => {
  function V(r) {
    switch (r) {
      case x:
      case F:
        return "Week";
      case Q:
        return "Uke";
      case N:
        return "Uge";
      case K:
      default:
        return "Vecka";
    }
  }
  function h(r) {
    return !!r?.startDate && !!r?.endDate;
  }
  const n = !m && h(t) && s;
  function v(r) {
    return X(r.startDate, r.endDate) ? o === F || o === x ? "MMM d" : "d MMM" : "PP";
  }
  const y = () => {
    if (f)
      return S(d);
    if (m)
      return `${V(o)} ${A(i)}`;
    if (n) {
      const r = v(t), j = b(t.startDate, r, { locale: o }), I = b(t.endDate, r, { locale: o });
      return `${j} - ${I}`.replace(/\./g, "");
    }
    return i ? b(i, "dd MMMM", { locale: o }) : S(d);
  }, H = () => {
    f ? k(Y(u(e))) : m ? a(q(i)) : n ? s({
      startDate: c(t.startDate),
      endDate: c(t.endDate)
    }) : a(c(i));
  }, U = () => {
    f ? k(C(u(e), 1)) : m ? a(J(i, 1)) : n ? s({
      startDate: D(t.startDate, 1),
      endDate: D(t.endDate, 1)
    }) : a(D(i, 1));
  }, M = u(/* @__PURE__ */ new Date()), $ = B || P && (O(e, M) || G(e, M));
  return /* @__PURE__ */ L(W, { justify: "space-between", align: "center", mb: Z.Small, children: [
    /* @__PURE__ */ p(
      l,
      {
        icon: w.Back,
        "aria-label": "Back",
        variant: "ghost",
        onClick: H,
        isDisabled: $
      }
    ),
    /* @__PURE__ */ p(z, { fontWeight: "500", fontFamily: E.SubHeader, fontSize: _.Large, children: y() }),
    /* @__PURE__ */ p(
      l,
      {
        icon: w.Forward,
        "aria-label": "Forward",
        variant: "ghost",
        onClick: U,
        isDisabled: T
      }
    )
  ] });
};
export {
  Fr as DatePickerHeader
};
